import useSWR from 'swr'
import { getApiVersion, http } from '../utils/domain'
import { stringifyQuery } from '../utils/query'

const prefix = (appId) => {
  return `${getApiVersion()}/apps/${appId}/users/org`
}

export const fetchOrgsListAll = (appId) => {
  return http()
    .get(
      `${prefix(appId)}/listAll`,
      {},
      {
        throwHttpErrors: false,
      }
    )
    .json()
}

// 获取用户相关定制信息
export const usersCustomInfo = (appId, tpl) => {
  const params = {
    purpose: 'user',
    tpl,
  }
  return http()
    .get(
      `${getApiVersion()}/apps/${appId}/informationStorage/my${stringifyQuery(
        params
      )}`
    )
    .json()
}

export const fetchOrgs = (appId) => {
  return http()
    .get(`${prefix(appId)}/list`, {
      throwHttpErrors: false,
    })
    .json()
}

export const fetchOrgsByIds = (appId, ids) => {
  return http()
    .get(`${prefix(appId)}/getByIds`, {
      searchParams: {
        ids: (ids || []).join(','),
      },
      throwHttpErrors: false,
    })
    .json()
}

// 根据组织ids获取组织信息列表
export const orgsInfoByIds = (appId, ids) => {
  return http()
    .get(`${prefix(appId)}/getByIds?ids=${ids}`)
    .json()
}

// 根据组织 ids 获取组织信息列表
export const orgsInfoByIdsSWR = (appId, ids) => {
  const { data, mutate, error } = useSWR(
    `${getApiVersion()}/apps/${appId}/org/getByIds?ids=${ids}`
  )
  return {
    orgs: data ? data.data : {},
    mutate,
    isLoading: false,
    isError: error,
  }
}

const getOrgTreeData = (appId) => {
  return http()
    .get(`${prefix(appId)}/tree`)
    .json()
}
// 获取组织树
export const orgTreeData = (appId) => {
  const { data, error, mutate } = useSWR('orgs', () => getOrgTreeData(appId))
  return {
    orgsData: data,
    isLoading: !error && !data,
    isError: error,
    orgMutate: mutate,
  }
}

// 添加组织
export const addOrg = (appId, data) => {
  return http()
    .post(`${prefix(appId)}`, data)
    .json()
}

// 编辑组织
export const editOrg = (appId, data) => {
  return http()
    .put(`${prefix(appId)}`, data)
    .json()
}

// 删除组织
export const deleteOrg = (appId, orgId) => {
  return http()
    .delete(`${prefix(appId)}/${orgId}`)
    .json()
}

// 组织中添加用户
export const addUsersToOrg = (appId, ids, orgId, roleId) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/users/search/add?orgId=${orgId}&ids=${ids}&roleId=${roleId}`
    )
    .json()
}

export const fetchOrgData = (appId) => {
  return http().get(`${getApiVersion()}/apps/${appId}/users/org/tree`).json()
}
